/* global HTMLElement */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useEffect, useRef, useState } from "react";
import { injectIntl } from "react-intl";
import { CSSTransition } from "react-transition-group";
import { FocusOn } from "react-focus-on";
import Icon from "./Icon";
import ErrorBoundary from "./ErrorBoundary";
import emulateSlide from "./QuickFavourites/emulateSlide";
import emulateChapter from "./QuickFavourites/emulateChapter";
var hasSomeParentClass = function(element, className) {
    return !!element && (element.classList.contains(className) || hasSomeParentClass(element.parentElement, className));
};
var hasSomeParentAttribute = function(element, attr) {
    return !!element && (element.getAttribute(attr) || hasSomeParentAttribute(element.parentElement, attr));
};
function QuickFavourites(props) {
    var hideButtonRef = useRef(null);
    var contentRef = useRef(null);
    var _useState = _slicedToArray(useState([]), 2), emulatedLinks = _useState[0], setEmulatedLinks = _useState[1];
    useEffect(function() {
        if (!contentRef.current) return;
        var chartLinksToEmulate = contentRef.current.querySelectorAll(".slide-link-emulated");
        if (!chartLinksToEmulate || !chartLinksToEmulate.length) {
            return;
        }
        var _emulatedLinks = [];
        Array.from(chartLinksToEmulate).forEach(function(link) {
            var target = parseInt(link.getAttribute("data-node-ref"), 10);
            if (!target) {
                return;
            }
            var localId = parseInt(target, 10);
            var claim = props.claims && props.claims.find(function(c) {
                return c.local_id === localId;
            });
            if (!claim) {
                link.classList.add("slide-link-emulated--not-found");
                return;
            }
            var node = props.nodes.find(function(n) {
                return n.id === claim.node_id;
            });
            if (!node) {
                link.classList.add("slide-link-emulated--not-found");
                return;
            }
            _emulatedLinks.push({
                node: node,
                element: link,
                chapterIndex: node.target_type === "Filter" ? props.getChapterIndex(node) : []
            });
        });
        setEmulatedLinks(_emulatedLinks);
    }, [
        props.quick_nav_cont
    ]);
    useEffect(function() {
        emulatedLinks.forEach(function(param) {
            var node = param.node, element = param.element, chapterIndex = param.chapterIndex;
            if (node.target_type === "Filter") {
                renderChapter(node, element, chapterIndex);
            } else {
                renderSlide(node, element);
            }
        });
    }, [
        emulatedLinks,
        props.favorites,
        props.completedSlides
    ]);
    useEffect(function() {
        var backButtons = Array.from(contentRef.current.querySelectorAll(".quick-favourites-smart-nav-button"));
        if (!backButtons.length) {
            return;
        }
        if (!props.quickFavOrigin) {
            backButtons.forEach(function(button) {
                return button.classList.add("quick-favourites-smart-nav-button--disabled");
            });
        } else {
            backButtons.forEach(function(button) {
                return button.classList.remove("quick-favourites-smart-nav-button--disabled");
            });
            backButtons.forEach(function(button) {
                var currentSlideNameElement = button.querySelector(".quick-favourites-smart-nav-button__chart-name");
                if (currentSlideNameElement) {
                    button.removeChild(currentSlideNameElement);
                }
                var slideName = document.createElement("span");
                slideName.classList.add("quick-favourites-smart-nav-button__chart-name");
                slideName.innerHTML = props.nodes.find(function(n) {
                    return n.id === props.quickFavOrigin;
                }).name;
                button.appendChild(slideName);
            });
        }
    }, [
        props.quickFavOrigin
    ]);
    var closeQuickFav = function() {
        props.setUIVisibilityState({
            quickFavourites: false
        });
    };
    var onClickBody = function(evnt) {
        if (evnt.target && hasSomeParentClass(evnt.target, "slide-link-emulated") && hasSomeParentAttribute(evnt.target, "data-node-ref")) {
            evnt.preventDefault();
            evnt.stopPropagation();
            var target = evnt.target.getAttribute("data-node-ref") || evnt.target.closest("[data-node-ref]") && evnt.target.closest("[data-node-ref]").getAttribute("data-node-ref");
            if (evnt.target.classList.contains("chart-menu__fav-btn")) {
                var emulatedLink = emulatedLinks.find(function(l) {
                    return l.element.getAttribute("data-node-ref") === target;
                });
                if (emulatedLink) {
                    props.toggleFavorite(emulatedLink.node.id);
                }
                return;
            }
            props.goTo(null, parseInt(target, 10), props.currentSlide);
            closeQuickFav();
        }
        if (evnt.target && hasSomeParentClass(evnt.target, "quick-favourites-smart-nav-button") && !!props.quickFavOrigin) {
            evnt.preventDefault();
            evnt.stopPropagation();
            props.goTo(props.quickFavOrigin, null);
            closeQuickFav();
        }
    };
    var bodyStyle = {};
    if (props.quick_nav_background_image) {
        bodyStyle.backgroundImage = "url('".concat(encodeURI(props.quick_nav_background_image), "')");
    }
    var renderChapter = function(node, element, chapterIndex) {
        var isChapterAvailable = props.isChapterAvailable(node);
        var trackableSlides = props.trackableSlidesInChapter(node);
        var trackableSlidesCount = trackableSlides.length;
        var trackableCompletedSlidesCount = trackableSlides.filter(function(id) {
            return props.completedSlides.indexOf(id) > -1;
        }).length;
        emulateChapter(node, element, {
            chapterIndex: chapterIndex,
            isChapterAvailable: isChapterAvailable,
            trackableSlidesCount: trackableSlidesCount,
            trackableCompletedSlidesCount: trackableCompletedSlidesCount,
            intl: props.intl
        });
    };
    var renderSlide = function(node, element) {
        var isVisited = props.isComplete(node.id);
        var isAvailable = props.isAvailable(node);
        var isFav = props.isFavorite(node.id);
        var isCurrentSlide = props.currentSlide === node.id;
        var slideIndex = props.getSlideIndex(node.id) + 1;
        var examStatus = node.target_type === "Exam" ? props.getSlideStatus(node.id) : "";
        var iconURL = props.iconURL;
        emulateSlide(node, element, {
            iconURL: iconURL,
            isVisited: isVisited,
            isAvailable: isAvailable,
            isFav: isFav,
            isCurrentSlide: isCurrentSlide,
            slideIndex: slideIndex,
            examStatus: examStatus,
            intl: props.intl
        });
    };
    return /*#__PURE__*/ React.createElement(CSSTransition, {
        in: props.visible,
        timeout: 300,
        classNames: "quick-favourites"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "quick-favourites",
        "aria-hidden": !props.visible,
        ref: contentRef
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, props.quick_nav_cont && /*#__PURE__*/ React.createElement(FocusOn, {
        enabled: props.visible,
        onEscapeKey: closeQuickFav,
        autoFocus: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "close-btn__container"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "close-btn",
        ref: hideButtonRef,
        onClick: function(evnt) {
            evnt.preventDefault();
            closeQuickFav();
            evnt.target.blur();
        },
        "aria-label": props.intl.formatMessage({
            id: "quick_favourites.close",
            defaultMessage: "Close quick favourites"
        })
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down",
        size: "m"
    }))), /*#__PURE__*/ React.createElement("div", {
        style: bodyStyle,
        className: "quick-favourites__body",
        onClick: onClickBody,
        dangerouslySetInnerHTML: {
            __html: props.quick_nav_cont
        }
    })))));
}
export default injectIntl(QuickFavourites);
